import { AuthenticationService, ConfigurationService } from '@philips-internal/oswald-ui-core/lib/services';
import { HttpMethod } from '@philips-internal/oswald-ui-core/lib/services/http-service';
import { applicationContext, Information, Establishment } from '@philips-internal/oswald-ui-foundation/lib/context';
import { HistoryService } from '@philips-internal/oswald-ui-core/lib/services/history-service';
import { APPLICATION_ENDPOINTS } from '../constants/application-endpoints';
import { APPLICATION_ROUTES } from '../constants/application-routes';
import { availableModulesMapper, ParametersModule } from './available-modules-mapper';
import  ResultsPortalRootController  from '../controllers/home/results-portal-root';
import UserContext from '../utils/user-context';

const defaultModules = {
  'examResults': { cdFunction: 'exam-results', name: 'result.exam-results.title', parameters: new Map([]) },
  'users': { cdFunction: 'users', name: 'results.user.management', parameters: new Map([]) },
  'profile': { cdFunction: 'profile', name: 'result.profile', parameters: new Map([]) },
} ;

const twsDefaultModules = [defaultModules.examResults, defaultModules.users, defaultModules.profile] as ParametersModule[];

function informationMapper(data: any): Information {// eslint-disable-line

  const {twsParameters: twsUserAvailableModules = [], currentEstablishment, userInformation, twsParameters} = data.body;

  twsUserAvailableModules.unshift(...twsDefaultModules);
  UserContext.twsUserAvailableModules = twsUserAvailableModules;

  const establishmentsAvailables = [{
    id: String(currentEstablishment.establishmentId),
    tradingName: currentEstablishment.companyName
  }] as unknown as Establishment[];

  return {
    establishment: {
      available: establishmentsAvailables,
      current: {
        id: String(currentEstablishment.establishmentId),
        locale: 'undefined',
        name: currentEstablishment.companyName,
        tradingName: currentEstablishment.companyName,
      },
    },
    module: {
      available: availableModulesMapper([], twsParameters)
    },
    profile: {
      available: [],
      current: {
        id: 1,
        name: 'undefined',
      },
    },
    sector: {
      available: [],
      current: {
        id: 0,
        name: '',
      },
    },
    user: {
      id: '1',
      language: 'undefined',
      locale: 'undefined',
      name: userInformation.name,
      username: ResultsPortalRootController.getTitleByType(),
      image: userInformation.userPhoto,
    },
  };
}

export function setupAuthentication(): void {
  ConfigurationService.setAuthenticationConfiguration({
    clientId: 'resultsportal',
    endpoints: {
      information: {
        url: APPLICATION_ENDPOINTS.INFORMATION,
        method: HttpMethod.GET,
      },
      refresh: {
        url: APPLICATION_ENDPOINTS.AUTHENTICATION,
        method: HttpMethod.POST,
      },
      revoke: {
        url: APPLICATION_ENDPOINTS.REVOKE,
        method: HttpMethod.POST,
      }
    },
    inactivity: {
      time: 15 * 60 * 1000,
    },
    routes: {
      home: '/results',
      inactivity: APPLICATION_ROUTES.LOGOUT_INACTIVITY,
      login: APPLICATION_ROUTES.LOGIN,
      forgotPassword: APPLICATION_ROUTES.FORGET_PASSWORD,
      custom: [
        /* Routes that can be accessed without authentication */
        APPLICATION_ROUTES.ACCOUNT_CREATION_COMPLETED,
        APPLICATION_ROUTES.ACCOUNT_CREATION_PROCESSING,
        APPLICATION_ROUTES.ACTIVE_USE,
        APPLICATION_ROUTES.ACTIVE_USE_FAIL,
        APPLICATION_ROUTES.ACTIVE_USE_SUCCESS,
        APPLICATION_ROUTES.ASSIGN_PRIVACY,
        APPLICATION_ROUTES.ASSIGN_TERMS_OF_USE,
        APPLICATION_ROUTES.FORGET_PASSWORD_REQUEST_FAILURE,
        APPLICATION_ROUTES.FORGET_PASSWORD_REQUEST_SUCCESS,
        APPLICATION_ROUTES.FORGET_PASSWORD_REQUEST_EMAIL_NOT_FOUND,
        APPLICATION_ROUTES.FORGET_PASSWORD_RESET_FAILURE,
        APPLICATION_ROUTES.FORGET_PASSWORD_RESET_SUCCESS,
        APPLICATION_ROUTES.NEW_USER,
        APPLICATION_ROUTES.RESET_PASSWORD,
      ]
    },
  });
  ConfigurationService.setEndpointMappers({
    // @ts-ignore
    information: informationMapper,
  });
  // logout
  AuthenticationService.listenLogout(() => {
    applicationContext.clearNavigationStack();
    applicationContext.closeModules();
    HistoryService.push('/login');
  });
}

